<template>
	<ul :class="['accordion', { dark: darkMode }]">
		<li v-for="(tab, index) in tabs" :key="index">
			<div
				class="title-wrapper"
				tabindex="0"
				:aria-label="tab.title"
				:aria-expanded="(!!tab.expanded).toString()"
				role="button"
				@click="toggleTab(index)"
				@keydown.enter="toggleTab(index)"
				@keydown.space="toggleTab(index)"
				@mousedown.prevent
			>
				<div class="heading-3" aria-hidden="true">{{ tab.title }}</div>
				<svgicon
					aria-hidden="true"
					name="arrow-right"
					:class="{ expanded: tab.expanded }"
				></svgicon>
			</div>
			<transition name="slide" mode="out-in">
				<div
					v-show="tab.expanded"
					:class="['component-wrapper', { expanded: tab.expanded }]"
				>
					<component :is="tab.component" v-bind="tab.props"></component>
				</div>
			</transition>
		</li>
	</ul>
</template>
<script>
import '../icons/arrow-right';

export default {
	props: {
		tabs: {
			type: Array,
			default: null
		},
		darkMode: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		toggleTab(index) {
			const currentTab = this.tabs[index];
			this.$set(currentTab, 'expanded', !currentTab.expanded);
		}
	}
};
</script>
<style lang="scss" scoped>
.accordion {
	display: block;
	list-style-type: none;
	padding: 0;
	margin: 0 0 32px 0;

	&.dark {
		li {
			box-shadow: none;
			background-color: $page-bgcolor;
			border: 0;
			padding: 0;

			.title-wrapper {
				padding: 24px 32px;
				.heading-3 {
					margin: 0;
					text-align: left;
				}
			}

			.component-wrapper {
				padding: 32px 48px 64px 48px;

				&.expanded {
					border-top: 1px solid $container-border;
				}
			}
		}
	}

	li {
		display: flex;
		flex-direction: column;
		align-items: center;
		border: 1px solid $container-border;
		border-radius: 6px;
		box-shadow: 0 8px 18px 0 rgba(0, 76, 208, 0.24);
		margin-top: 16px;
		padding: 0;

		.title-wrapper {
			display: flex;
			width: 100%;
			align-items: center;

			padding: 0 16px;

			.heading-3 {
				margin: 16px 0;
				flex-grow: 1;
			}

			svg {
				fill: $primary-state;
				transform: rotate(90deg);
				transition: transform 0.5s linear;

				&.expanded {
					transform: rotate(-90deg);
					transition: transform 0.5s linear;
				}
			}

			@media (any-hover: hover) {
				&:hover {
					cursor: pointer;
					svg {
						fill: $hover-state;
					}
				}
			}
		}

		.component-wrapper {
			width: 100%;
			padding: 8px 32px 32px 32px;
		}

		.slide-enter {
			transform: scaleY(0);
		}

		.slide-enter-active {
			transition: transform 0.5s ease;
			transform-origin: top;
		}

		.slide-leave-to {
			transform: scaleY(0);
		}

		.slide-leave-active {
			transition: transform 0.3s ease;
			transform-origin: top;
		}
	}
}
</style>
